import React, { FC, useEffect, useState } from 'react';
import { LandscapeProjectsAddProjectsImpactCommodityTemplate } from '../../templates';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from '../../../store/store';
import { useNavigate, useParams } from 'react-router-dom';
import LandscapeProjectNotSavedInfoPage from '../LandscapeProjectNotSavedInfoPage';
import {
  deleteProjectCommodity,
  fetchCommoditiesByProjectId,
  fetchProjectCommoditiesByProjectId,
  saveProjectCommodity,
} from '../../../store/tradeAPI/projectCommodity/reducers/project-commodity.slice';
import Spinner from '../../atoms/Spinner/Spinner';
import { CommodityResponseDto } from '../../../store/tradeAPI/commodity/dto/response/commodity-response.dto';
import { fetchCommodities } from '../../../store/tradeAPI/commodity/reducers/commodity.slice';
import { ProjectCommoditySaveRequestDto } from '../../../store/tradeAPI/projectCommodity/dto/request/project-commodity-save-request.dto';
import { getUUID } from '../../../utils/UUID';
import { showError } from '../../../utils/Notifications';

interface LandscapeProjectsAddProjectsImpactCommodityPageProps {}

const LandscapeProjectsAddProjectsImpactCommodityPage: FC<
  LandscapeProjectsAddProjectsImpactCommodityPageProps
> = () => {
  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();

  const { projectId } = useParams();

  const { commodities, status: commodityStatus } = useSelector(
    (state: RootState) => state.commoditySlice
  );

  const { commodities: projectCommodities, status: projectCommodityStatus } =
    useSelector((state: RootState) => state.projectCommoditySlice);

  const [showModal, setShowModal] = useState<boolean>(false);

  const [selectedCommodity, setSelectedCommodity] =
    useState<CommodityResponseDto>();

  useEffect(() => {
    if (!projectId || projectId === 'new-project') {
      return;
    }
    // Fetching all commodities for the modal dropdown
    dispatch(fetchCommodities());
    // Fetching commodities to display in the table. This function
    // is implemented in the project commodity service
    dispatch(fetchCommoditiesByProjectId(projectId));
  }, [dispatch, projectId]);

  const handleSubmit = async () => {
    if (!selectedCommodity) {
      showError('Please selected a commodity!');
      return;
    }
    const request: ProjectCommoditySaveRequestDto = {
      commodityId: selectedCommodity!.id,
      id: getUUID(),
      projectId: projectId!,
      published: true,
    };

    await dispatch(saveProjectCommodity(request));
    await dispatch(fetchCommoditiesByProjectId(projectId!));
    setShowModal(false);
  };

  const handleDelete = async (id: string) => {
    await dispatch(fetchProjectCommoditiesByProjectId(projectId!))
      .unwrap()
      .then((projectCommodities) => {
        const pc = projectCommodities.find((c) => c.commodityId === id)!;
        dispatch(deleteProjectCommodity(pc.id))
          .unwrap()
          .then(() => {
            dispatch(fetchCommoditiesByProjectId(projectId!));
          });
      });
  };

  const handleEdit = (id: string) => {
    navigate(`/commodities/edit/${id}`);
  };

  if (projectCommodityStatus === 'loading' || commodityStatus === 'loading') {
    return <Spinner />;
  }

  return !projectId || projectId === 'new-project' ? (
    <LandscapeProjectNotSavedInfoPage />
  ) : (
    <LandscapeProjectsAddProjectsImpactCommodityTemplate
      commodities={commodities ?? []}
      projectCommodities={projectCommodities ?? []}
      showModal={showModal}
      setShowModal={setShowModal}
      setSelectedCommodity={setSelectedCommodity}
      handleSubmit={handleSubmit}
      handleDelete={handleDelete}
      handleEdit={handleEdit}
    />
  );
};

export default LandscapeProjectsAddProjectsImpactCommodityPage;
